import { checkRuleEnabled } from './checkRuleEnabled';

const CHECK_CLASS_TYPE_IS_ECONOMY: { [key: string]: boolean } = {
  A: true,
  G: true,
  P: true,
  Q: true,
  N: true,
  R: true,
  T: true,
  E: true,
};

export const isMealCheck = (operatingAirline: string, duration: number, mealDuration: number, isMeal: boolean | string) => {
  if (operatingAirline === 'VN') {
    return (duration >= 120);
  }
  if (
    checkRuleEnabled(isMeal)
    && duration
    && duration >= +(mealDuration || 0) && operatingAirline !== 'BL') {
    return true;
  }
  return false;
};
